module.exports = __webpack_public_path__ + "static/media/erik.3d733eb3.png";